module.exports = __webpack_public_path__ + "static/hand-heart-icon-mobile-d2c2dae91997949356c9d44b41e4e45a.png";